import * as dayjs from 'dayjs';

export class QuickEditFormModel {
  estimatedOut: dayjs.Dayjs = null;
  estimatedIn: dayjs.Dayjs = null;
  estimatedOff: dayjs.Dayjs = null;
  actualOut: dayjs.Dayjs = null;
  actualIn: dayjs.Dayjs = null;
  actualOff: dayjs.Dayjs = null;
}
